/* eslint-disable react/jsx-curly-newline */
import CheckboxCustom from '@components/common/CheckboxCustom/CheckboxCustom';
import React from 'react';
import CollapsibleContainer from '@components/common/CollapsibleContainer/CollapsibleContainer';
import {
  HotelVibesFilter as HotelVibesFilterType,
  FilterOptionType,
  SrpFilterCount,
  SrpFilterOptions,
  SrpFilters,
} from '@customTypes/srp-filters';
import { FILTER_CATEGORY_HOTEL_VIBES } from '@constants/filterValues';

type Props = {
  srpFilters: SrpFilters | undefined;
  setFilters: (category: string, name: string, eventName: string) => void;
  filterOptions: SrpFilterOptions | undefined;
  filterCount: SrpFilterCount | undefined;
  isMobile: boolean;
};

function VibesFilter({ srpFilters, setFilters, filterOptions, filterCount, isMobile }: Props) {
  const containerHeight =
    filterOptions && filterOptions.hotel_vibes ? filterOptions.hotel_vibes.length * 45 : 225;

  return (
    <div>
      {filterOptions && filterOptions.hotel_vibes && (
        <CollapsibleContainer
          title={`Vibes ${
            filterCount && filterCount?.hotel_vibes > 0 && !isMobile
              ? `(${filterCount?.hotel_vibes})`
              : ''
          }`}
          height={`${containerHeight}px`}
        >
          <div className="flex flex-col overflow-hidden gap-5 mt-0.5 d:mt-0">
            {filterOptions.hotel_vibes.map((item: FilterOptionType) => (
              <div className="flex items-center" key={item.id}>
                <CheckboxCustom
                  label={item.description}
                  isChecked={
                    srpFilters
                      ? srpFilters.hotel_vibes[
                        item.name.toString().toLocaleLowerCase() as keyof HotelVibesFilterType
                      ] || srpFilters.hotel_vibes[item.name as keyof HotelVibesFilterType]
                      : false
                  }
                  setIsChecked={() =>
                    setFilters(
                      FILTER_CATEGORY_HOTEL_VIBES,
                      `${item.name.toString().toLowerCase()}`,
                      `filters_hotel_vibes_${item.name}_clicked`,
                    )
                  }
                  id={item.name.toString()}
                  isDarkBorder
                />
              </div>
            ))}
          </div>
        </CollapsibleContainer>
      )}
    </div>
  );
}

export default VibesFilter;
